import { apiInstanceImg } from '../../../../backend-api.setup'
import { ApiPathConfig } from '../../../../../config/ApiPathConfig'

const PostChroniqueurPreview = (file: File, id_ean: string) => {
  return apiInstanceImg.post(ApiPathConfig.CHRONIQUEUR_PREVIEW, {
    file,
    id_ean,
  })
}

export default PostChroniqueurPreview
